//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQButton from "@/components/Generics/AQButton/AQButton.vue";

export default {
    name: "PhotoCapture",
    components: {
        AQButton
    },
    props: {
        devices: { type: Array, default: () => [] }
    },
    data() {
        return {
            showVideo: false,
            picture: null,
            isValid: false,
            showRetake: false,
            deviceId: null
        };
    },

    mounted() {
        this.videoPlayer = this.$refs.player;
        this.canvasElement = this.$refs.canvas;
        this.streamUserMediaVideo();
    },

    methods: {
        streamUserMediaVideo() {
            const id = this.deviceId ? this.deviceId : this.devices[0].deviceId;
            navigator.mediaDevices
                .getUserMedia({ video: {
                    deviceId: id
                } })
                .then(stream => {
                    this.$emit("newStream", stream);
                    this.videoPlayer.srcObject = stream;
                    this.showVideo = true;
                })
                .catch((err) => {
                    if (err) {
                        this.$emit("cameraIsUsed", true);
                    }
                });
        },
        capture() {
            this.showVideo = false;
            const aspect = this.videoPlayer.videoHeight / this.videoPlayer.videoWidth;
            const wantedWidth = window.innerWidth;
            const height = Math.round(wantedWidth * aspect);
            this.canvasElement.width = wantedWidth;
            this.canvasElement.height = height;
            const context = this.canvasElement.getContext("2d");
            context.drawImage(this.videoPlayer, 0, 0, this.canvasElement.width, this.canvasElement.height);
            this.stopVideoStream();
            this.picture = this.$refs.canvas.toDataURL();
            this.$emit("modifyImage", this.picture);
            this.showRetake = true;
        },

        cancel() {
            this.showRetake = false;
            this.showVideo = true;
            this.$emit("cancelPhoto");
            this.streamUserMediaVideo();
        },
        stopVideoStream() {
            if (!(this.$refs.player && this.$refs.player.srcObject)) return;
            this.$refs.player.srcObject.getVideoTracks().forEach(track => {
                track.stop();
            });
        },
        switchCamera() {
            if (this.devices.length && this.showVideo) {
                const indexId = this.devices.findIndex(element => element.deviceId === this.deviceId);
                if (indexId < this.devices.length - 1) {
                    const nextDevice = indexId + 1;
                    this.deviceId = this.devices[nextDevice].deviceId;
                    this.streamUserMediaVideo();
                } else {
                    this.deviceId = this.devices[0].deviceId;
                    this.streamUserMediaVideo();
                }
            }
        }

    }
};
